import { createContext } from 'react';

const InitialState = {
  baseAssignedTeams: [],
  baseAssignedLicenses: [],
  assignedTeams: [],
  assignedLicenses: [],
  licensesToAdd: [],
  removedVoiceAccess: false,
  removedNextOsAccess: false,
  isLicensesLoading: true,
  isTeamsLoading: true,
};

const actionTypes = {
  SET_BASE_ASSIGNED_TEAMS: 'SET_BASE_ASSIGNED_TEAMS',
  SET_BASE_ASSIGNED_LICENSES: 'SET_BASE_ASSIGNED_LICENSES',
  SET_ASSIGNED_TEAMS: 'SET_ASSIGNED_TEAMS',
  SET_ASSIGNED_LICENSES: 'SET_ASSIGNED_LICENSES',
  SET_LICENSES_TO_ADD: 'SET_LICENSES_TO_ADD',
  REMOVE_LICENSE: 'REMOVE_LICENSE',
  ADD_LICENSE: 'ADD_LICENSE',
  SET_LICENSES_LOADING: 'SET_LICENSES_LOADING',
  SET_TEAMS_LOADING: 'SET_TEAMS_LOADING',
};

const UserDrawerContext = createContext(InitialState);

export { UserDrawerContext, InitialState, actionTypes };
